export default {
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
};
